import { render } from "./9.WhatWeOfferSection.vue?vue&type=template&id=593a6359&scoped=true"
import script from "./9.WhatWeOfferSection.vue?vue&type=script&lang=js"
export * from "./9.WhatWeOfferSection.vue?vue&type=script&lang=js"

import "./9.WhatWeOfferSection.vue?vue&type=style&index=0&id=593a6359&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593a6359"]])

export default __exports__